import { SHOW_MENU, SET_DESC_FORMAT } from './actions';
import { RECEIVE_RGEO_ADDRESS } from '../reverseGeocoding/actions';

const DefaultState = {
  active: false, //{address: '', coords: []}
  items: [
    {name: 'test'}
  ],
  pixel: [],
  coords: [],
  address: null,
  text: null,
  format: null
};

const contextmenu = (state = DefaultState, action) => {
  switch (action.type) {
    case RECEIVE_RGEO_ADDRESS:

      if(state.coords[0] === action.coords[0] && state.coords[1] === action.coords[1]) {

        state.address = action.address;
      }
      
      return Object.assign({}, state);
    case SET_DESC_FORMAT:

      state.format = action.format;
      return Object.assign({}, state);
    case SHOW_MENU:
      var newstate = {
        active: (action.data ? true : false), 
        pixel: (action.data ? action.data.pixel : []), 
        coords: (action.data ? action.data.coord : []),
        address: '...',
        text: ''
      };
      
      return Object.assign({}, state, newstate);
    default:
      return state;
  }
};

export {contextmenu};